const ACCOUNT_AREA_ROUTE_NAMES = new Set([
  'meus_negocios_index',
  'minha_lais_index',
  'minha_lais_whatsapp_catalog_index',
  'minha_lais_whatsapp_catalog_new',
  'minha_lais_whatsapp_catalog_show',
  'minha_lais_whatsapp_catalog_edit',
  'general_settings_index',
  'administracao_index',
  'administracao_qualidade_fraude_index',
  'administracao_parceiros_index',
  'conta_index',
  'deletar_conta_sucesso_index',
  'agent_list',
  'settings_teams_list',
  'settings_teams_new',
  'settings_teams_finish',
  'settings_teams_add_agents',
  'settings_teams_edit',
  'settings_teams_edit_members',
  'settings_teams_edit_finish',
  'notifications_index',
  'security_settings_index',
]);

const REPORT_AREA_ROUTE_NAMES = new Set([
  'relatorio_index',
  'desempenho_equipe_index',
  'metas_index',
  'operational_history_index',
  'account_overview_reports',
  'conversation_reports',
  'agent_reports',
  'inbox_reports',
  'label_reports',
  'team_reports',
  'agent_reports_index',
  'agent_reports_show',
  'inbox_reports_index',
  'inbox_reports_show',
  'team_reports_index',
  'team_reports_show',
  'label_reports_index',
  'label_reports_show',
  'csat_reports',
  'sla_reports',
  'bot_reports',
]);

export const isAccountAreaRoute = routeName =>
  ACCOUNT_AREA_ROUTE_NAMES.has(routeName);

export const isReportAreaRoute = routeName =>
  REPORT_AREA_ROUTE_NAMES.has(routeName);
